module.exports = __webpack_public_path__ + "static/iphone6plus-sketch-pad.7073b8ae.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/sketchpad/iphone6plus-sketch-pad.pdf
// module id = 1539
// module chunks = 119029729424783